module.exports = __webpack_public_path__ + "media/images/en/upload-online-12b87efc9fe0327e27a626dd26c121cd.png";